import {
    setSocket,
    receiveChatMessage,
    receiveRoomStateMessage,
    receiveAllMessage,
    receiveTtmMessage,
    receiveAudioMessage,
    receiveNoteMessage,
    deleteNoteMessage,
    sendSocketMessage,
    populateDummyNotesMessages,
    setIsIframeShared,
    setSenderIdForDummyNotes,
} from 'store/actions/WebSocket'

import store from '../index'

const { dispatch } = store

export const dispatchReceiveChatMessage = message =>
    dispatch(receiveChatMessage(message))

export const dispatchReceiveTtmMessage = message =>
    dispatch(receiveTtmMessage(message))

export const dispatchReceiveRoomStateMessage = message =>
    dispatch(receiveRoomStateMessage(message))

export const dispatchReceiveAllMessage = message =>
    dispatch(receiveAllMessage(message))

export const dispatchSetSocket = socket => dispatch(setSocket(socket))

export const dispatchReceiveAudioMessage = message =>
    dispatch(receiveAudioMessage(message))

export const dispatchReceiveNoteMessage = message =>
    dispatch(receiveNoteMessage(message))

export const dispatchPopulateDummyNotesMessages = messages =>
    dispatch(populateDummyNotesMessages(messages))

export const dispatchSetSenderIdForDummyNotes = userId =>
    dispatch(setSenderIdForDummyNotes(userId))

export const dispatchDeleteNoteMessage = message =>
    dispatch(deleteNoteMessage(message))

export const dispatchSendSocketMessage = message =>
    dispatch(sendSocketMessage(JSON.stringify(message)))

export const dispatchSetIsIframeShared = message =>
    dispatch(setIsIframeShared(message))
